import { defineStyle } from "@chakra-ui/styled-system"
import type { StyleConfig, StyleFunctionProps } from "@chakra-ui/theme-tools"

const variantSolid = defineStyle((props: StyleFunctionProps) => {
  const { colorScheme } = props

  return {
    container: {
      boxShadow: "0 2px 20px 0 var(--chakra-colors-blackAlpha-100)",
      ...(colorScheme === "quaternary" && {
        color: "neutrals.600",
        bg: "neutrals.200",
      }),
      ...(colorScheme === "tertiary" && {
        color: "neutrals.700",
        bg: "white",
      }),
      ...(colorScheme === "primary" && {
        bg: "main.700",
      }),
      ...(colorScheme === "red" && {
        bg: "error.500",
      }),
      ...(colorScheme === "error" && {
        bg: "pink.100",
        color: "pink.900",
      }),
    },
  }
})

const variantRounded = defineStyle((props: StyleFunctionProps) => {
  const { colorScheme } = props

  return {
    container: {
      py: 1,
      px: 2,
      color: "text.body",
      fontSize: 12,
      fontWeight: 400,
      borderRadius: "full",
      bg: "neutrals.100",
      border: "1px solid",
      borderColor: "neutrals.300",
      ...(colorScheme === "primary" && {
        bg: "surface.brand",
        borderColor: "surface.brand",
        color: "text.action",
      }),
    },
    closeButton: {
      w: 4,
      h: 4,
      fontSize: 18,
      color: "neutrals.850",
      border: "none",
      ...(colorScheme === "primary" && {
        color: "text.action",
      }),
    },
  }
})

/**
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/tag.ts}
 */
export const Tag: StyleConfig = {
  baseStyle: {
    container: {
      fontWeight: 600,
    },
  },
  variants: {
    solid: variantSolid,
    rounded: variantRounded,
  },
  sizes: {
    sm: {
      container: {
        fontSize: 10,
      },
    },
    md: {
      container: {
        fontSize: 12,
      },
    },
    lg: {
      container: {
        fontSize: 12,
      },
    },
  },
  defaultProps: {
    variant: "solid",
    colorScheme: "secondary",
  },
}
